import React from 'react'
import { StyledLogo } from 'component-library/section-header/SectionHeader/SectionHeaderLogo/SectionHeaderLogo.styled'

const trueStoriesSectionHeaderLogo = require('./assets/true-stories-section-header-logo.png')
const sunriseSectionHeaderLogo = require('./assets/sunrise-section-header-logo.png')
const theDailyEditionSectionHeaderLogo = require('./assets/the-daily-edition-section-header-logo.png')
const theMorningShowSectionHeaderLogo = require('./assets/the-morning-show-section-header-logo.png')

interface Props {
    section: string
}

export const SectionHeaderLogo: React.FC<Props> = ({ section }) => {
    switch (section) {
        case 'sunday-night': {
            return <StyledLogo alt="True Stories" src={trueStoriesSectionHeaderLogo} />
        }
        case 'sunrise': {
            return <StyledLogo alt="Sunrise" src={sunriseSectionHeaderLogo} />
        }
        case 'the-daily-edition': {
            return <StyledLogo alt="The Daily Edition" src={theDailyEditionSectionHeaderLogo} />
        }
        case 'the-morning-show': {
            return <StyledLogo alt="The Morning Show" src={theMorningShowSectionHeaderLogo} />
        }

        default:
            return null
    }
}
